<template>
    <div class="modal-mask">
        <div class="reveal-modal large open modal-container" style="display: block; opacity: 1; visibility: visible;">
          <header data-draggable-modal="" class="draggable">
            <div class="title">
                <slot name="header">-</slot>
            </div>
          </header>
          <div class="content policy-modal">
                <div class="content">
                    <div class="row">
                        <div class="form-col large-24">
                            <slot name="body">-</slot>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-col large-24">
                        <div class="buttons small">
                            <div class="left"><a class="button secondary small" @click="close">Close</a></div>
                        </div>
                    </div>
                </div>
          </div>
          <a class="close-reveal-modal" @click="close">×</a>
        </div>
    </div>
</template>

<script>
  export default {
    name: "modal",
    methods: {
      close(){
        this.$emit('close');

        // fix for foundation modal
        this.$nextTick(()=>{
          for(let node of document.querySelectorAll('.reveal-modal-bg')){
            node.style.display = "none"
          }
        })

      }
    }
  }
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-container {
        display: table-cell;
        vertical-align: middle;
    }


</style>